import { Fragment, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import AmzonLogo from '../image/amazon-logo.svg'
import ImageIcon from '../image/image-icon.svg'
import ShareIcon from '../image/share-icon.svg'
import { Button } from '@material-ui/core';
import { Snackbar } from '@material-ui/core';
import { Slide } from '@material-ui/core';
import React from 'react';
import BookData from '../data/bookData.json'
// import Alert from '@mui/material/Alert';
// import Stack from '@mui/material/Stack';


const EndButtons = ( {amazonLink, imageLink} ) => {
    
const [copied, setCopied] = useState(false);
    
 function copy() {
  const el = document.createElement('input');
  el.value = window.location.href;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}

function SlideTransition(props) {
    return <Slide {...props} direction="up" />;
  }

  const [state, setState] = React.useState({
    open: false,
    Transition: Slide,
  });

  const handleClick = (Transition) => () => {
    setState({
      open: true,
      Transition,
    });

    copy();
  };

  const handleClose = () => {
    setState({
      ...state,
      open: false,
    });
  };

   
    
 
    
    return ( 
        <div className='end-button'>

            {/* <a href={amazonLink}><main className='amazon-button'><img src = {AmzonLogo}/></main></a> */}

            <a href={imageLink}><main className='original-image-button'><img src = {ImageIcon}/>Original Image</main></a>

            <main className='share-button' onClick={handleClick(SlideTransition)}><img src = {ShareIcon}/>Share Link</main>
            <Snackbar className='snackbar' ContentProps={{
                 sx: {
                    backgroundColor: "var(--secondary)",
                    color: 'var(--fontcolor)',
                    boxShadow: 'none',
                    border: '1px solid var(--outline)',
                 }
                }}
                autoHideDuration={1000}
                open={state.open}
                onClose={handleClose}
                TransitionComponent={state.Transition}
                message="Link copied to clipboard"
                key={state.Transition.name}
              />
        </div>
        
     );
}
 
export default EndButtons;